module.exports = __webpack_public_path__ + "static/media/TaxBase_Cores.abade515.png";